// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zsyllsjuuyhcujduopdv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpzeWxsc2p1dXloY3VqZHVvcGR2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkzMDkwNzQsImV4cCI6MjA2NDg4NTA3NH0.CqGvZgucLckUBMzOXzDTJN4tGkea9z6UYQ4wdkz_lDw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);